import moment from 'moment';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import { AffectationResponse } from '../Models/Planning/Affectation';
import { PlanningResponse } from '../Models/Planning/Planning';
import { SetPlanning } from '../Models/Planning/SetPlanning';
import { BaseDataService } from './Base/BaseDataService';

export const PlanningEndpoints = {
    PLANNING: '/api/v1/back/planning',
    PUBLISH_PLANNING: '/api/v1/back/planning/publish',
    AFFECTATION: '/api/v1/back/planning/affectations',
    EXPORT: '/api/v1/back/planning/export',
};

export interface IPlanningDataService {
    getPlanning: (
        cts: XHRRequestCanceler,
        start_date: Date,
        end_date: Date
    ) => Promise<PlanningResponse>;

    setPlanning: (
        cts: XHRRequestCanceler,
        setPlanning: SetPlanning
    ) => Promise<BaseApiDataResponse>;

    getAffectations: (cts: XHRRequestCanceler) => Promise<AffectationResponse>;

    publishPlanning: (
        cts: XHRRequestCanceler,
        week_start_date: Date
    ) => Promise<BaseApiDataResponse>;
}

class PlanningDataService extends BaseDataService implements IPlanningDataService {
    public publishPlanning = async (
        cts: XHRRequestCanceler,
        week_start_date: Date
    ): Promise<BaseApiDataResponse> => {
        return await this.post(
            PlanningEndpoints.PUBLISH_PLANNING,
            { week_start_date: moment(week_start_date).format() },
            cts
        );
    };

    public setPlanning = async (
        cts: XHRRequestCanceler,
        setPlanning: SetPlanning
    ): Promise<BaseApiDataResponse> => {
        setPlanning.affectations = setPlanning.affectations.map((affectation) => {
            affectation.start_date = moment(affectation.local_start_date).format();
            return affectation;
        });
        setPlanning.comments = setPlanning.comments.map((comment) => {
            comment.date = moment(comment.local_date).format();
            return comment;
        });
        return await this.put<BaseApiDataResponse>(PlanningEndpoints.PLANNING, setPlanning, cts);
    };

    public getPlanning = async (
        cts: XHRRequestCanceler,
        start_date: Date,
        end_date: Date
    ): Promise<PlanningResponse> => {
        return await this.get<PlanningResponse>(PlanningEndpoints.PLANNING, cts, {
            params: {
                start_date: moment(start_date).format(),
                end_date: moment(end_date).format(),
            },
        });
    };

    public getAffectations = async (cts: XHRRequestCanceler): Promise<AffectationResponse> => {
        return await this.get<AffectationResponse>(PlanningEndpoints.AFFECTATION, cts);
    };
}

const PlanningDataServiceName = 'PlanningDataService';

export { PlanningDataService, PlanningDataServiceName };
